import { FC } from 'react'
import { useFormik } from 'formik'
import { Button, LoadingIndicator, StarInput, TextArea, useModal } from '../../../../components'
import { ButtonType, showAlert, showError } from '../../../../../_metronic/helpers'
import { avaliacaoNPSAtendimento } from '../../core/_requests'
import { AvaliacaoAtendimentoDtoCreate } from '../../core/_models'
import { useT } from '_metronic/i18n/Metronici18n'

type IProps = {
  protocolo: string
}

export const NpsModal: FC<IProps> = ({ protocolo }) => {
  const { closeModal } = useModal()
  const { t } = useT()

  const formik = useFormik({
    initialValues: {
      scoreTelekit: 0,
      scoreAtendimento: 0,
      scoreEstabelecimento: 0,
      comentario: '',
    },

    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        const data: AvaliacaoAtendimentoDtoCreate = {
          ...values,
        }
        await avaliacaoNPSAtendimento(protocolo, data)
        showAlert({ title: 'Sucesso!', text: 'Avaliação salva com sucesso!', icon: 'success' })
        closeModal()
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  const handleChange = (name: string, value: number) => {
    formik.setFieldValue(name, value)
  }

  return (
    <div>
      <h4 className='text-center mb-4'>
        Sua Opinião é Importante! Avalie a Tecnologia, o Atendimento Médico e o Estabelecimento
        Parceiro.
      </h4>

      <div className='mb-4'>
        <p className='mb-2'>
          Como você avalia a facilidade de uso e a qualidade técnica da plataforma?
        </p>
        <div className='d-flex justify-content-center'>
          <StarInput
            name='scoreTelekit'
            value={formik.values.scoreTelekit}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className='mb-4'>
        <p className='mb-2'>O médico foi claro, atencioso e dedicou o tempo necessário?</p>
        <div className='d-flex justify-content-center'>
          <StarInput
            name='scoreAtendimento'
            value={formik.values.scoreAtendimento}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className='mb-4'>
        <p className='mb-2'>
          O estabelecimento ofereceu suporte adequado e condições confortáveis?
        </p>
        <div className='d-flex justify-content-center'>
          <StarInput
            name='scoreEstabelecimento'
            value={formik.values.scoreEstabelecimento}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className='mb-4'>
        <p className='mb-2'>Comentários e Observações</p>
        <div className='d-flex justify-content-center'>
          <TextArea
            placeholder='Digite seu comentário'
            value={formik.values.comentario}
            onChange={(e) => formik.setFieldValue('comentario', e.target.value)}
          />
        </div>
      </div>

      <div className='d-flex justify-content-center mt-4'>
        <Button
          type={ButtonType.Reset}
          className='btn-secondary me-3'
          onClick={closeModal}
          disabled={formik.isSubmitting}
        >
          {t('common.cancel')}
        </Button>
        <Button
          className='btn-primary'
          onClick={() => formik.handleSubmit()}
          disabled={formik.isSubmitting}
        >
          {formik.isSubmitting ? <LoadingIndicator /> : t('common.send')}
        </Button>
      </div>
    </div>
  )
}
